import authBaseHttpRequest from './authBaseHttpRequest';

export const getAgencyRewardDetails = () => {
  return authBaseHttpRequest({
    method: 'get',
    url: '/reward/get_agency_detail/',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};

export const updateAgencyRewardDetails = ({params}) => {
  return authBaseHttpRequest({
    method: 'patch',
    url: '/reward/activity_update/',
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};

export const getEstimatedMonthlyCost = () => {
  return authBaseHttpRequest({
    method: 'get',
    url: '/reward/estimated_monthly_cost/',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};
